import { EXPIRATION_AFTER_ISSUED_MESSAGE } from '../../promotion-credit/expiration-after-issued-message.js';
import { isExpirationAfterIssued } from '../../promotion-credit/is-expiration-after-issued.js';
/** Skips a missing date because the server re-checks the order once it has applied the defaults. */
export function refineExpirationAfterIssued(value, context) {
    if (!value.dateApplicable || !value.expirationDate)
        return;
    if (!isExpirationAfterIssued(value.dateApplicable, value.expirationDate)) {
        context.addIssue({
            code: 'custom',
            message: EXPIRATION_AFTER_ISSUED_MESSAGE,
            path: ['expirationDate'],
        });
    }
}
//# sourceMappingURL=refine-credit-dates.js.map